import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ApplicationClientCommonModule } from "@sdbn/appclient";
import { MaterialModule } from "@sdbn/appclient";
import { CommonTranslationModule } from "@sdbn/common";
import { DictionaryModule } from "@sdbn/appclient";
import { TmcYardCommonModule } from "../common.module";
import { StructureSelectionDialogComponent } from "./structure-selection-dialog/component/structure-selection-dialog/structure-selection-dialog.component";
import { StructureSelectionFieldComponent } from "./structure-selection-field/component/structure-selection-field.component";
import { StationDetailsComponent } from "./structure-selection/component/station-details/station-details.component";
import { StructureGroupDetailsComponent } from "./structure-selection/component/station-group-details/structure-group-details.component";
import { StationSetDetailsComponent } from "./structure-selection/component/station-set-details/station-set-details.component";
import { StructureSelectionComponent } from "./structure-selection/component/structure-selection/structure-selection.component";

@NgModule({
  declarations: [
    StructureSelectionDialogComponent,
    StationSetDetailsComponent,
    StationDetailsComponent,
    StructureGroupDetailsComponent,
    StructureSelectionFieldComponent,
    StructureSelectionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ApplicationClientCommonModule,
    DictionaryModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    //TmcLegacyModule
  ],
  exports: [
    StructureSelectionDialogComponent,
    StationSetDetailsComponent,
    StationDetailsComponent,
    StructureGroupDetailsComponent,
    StructureSelectionFieldComponent,
    StructureSelectionComponent
  ]
})
export class StructureSelectionModule { }
